/**
 * Global Anchor Scroll
 * Accounts for Shopify's sticky header.
 * Instant navigation, no smooth scrolling.
 */

(() => {
  const header = document.querySelector('.section-header');

  if (!header) return;

  function updateHeaderOffset() {
    const headerHeight = header.getBoundingClientRect().height;

    document.documentElement.style.setProperty(
      '--anchor-header-offset',
      `${Math.ceil(headerHeight)}px`
    );
  }

  updateHeaderOffset();

  window.addEventListener('resize', updateHeaderOffset);

  if ('ResizeObserver' in window) {
    new ResizeObserver(updateHeaderOffset).observe(header);
  }

  window.addEventListener('load', () => {
    updateHeaderOffset();

    if (window.location.hash) {
      const id = decodeURIComponent(window.location.hash.substring(1));
      const target = document.getElementById(id);

      if (target) {
        target.scrollIntoView({
          behavior: 'instant',
          block: 'start'
        });
      }
    }
  });
})();